<template>
  <div class="iphone-container">
    <!-- iPhone Frame -->
    <div class="iphone-frame">
      <!-- Notch -->
      <div class="iphone-notch">
        <div class="camera"></div>
        <div class="sensor"></div>
        <div class="speaker"></div>
      </div>

      <!-- Screen Content -->
      <div class="screen">
        <!-- Background Image (from pointOverview, no watchers) -->
        <div
            class="background-image"
            v-if="previewImage"
            :style="{ backgroundImage: 'url(' + previewImage + ')' }"
        ></div>

        <!-- Points Overview Card (from pointOverview, no watchers) -->
        <div class="points-card">
          <h4>{{ title }}</h4>
          <h1 class="points"><strong>1.070</strong> <small>Punkte</small></h1>
          <!-- Only show expiring points if initially set to true -->
          <p class="expiring-points" v-if="showExpiringPoints">
            <span>{{ expiringPointsButton }} 376</span>
          </p>
          <button class="info-btn" style="pointer-events: none;">Mehr Infos</button>
        </div>

        <!-- Progress / Current Level Section (dynamically updated) -->
        <div class="level-section" v-if="showCurrentLevel">
          <!-- Display your custom text, or a placeholder if empty -->
          <p class="current-level-text">
            {{ currentLevelText }} @aktueller_status
          </p>
          <!-- Milestones & Current Position Example -->
          <div class="progress-wrapper">
            <!-- Base progress bar -->
            <div class="progress-bar" :style="{ backgroundColor: progressBaseColor }">
              <!-- Filled portion at 65% for demonstration -->
              <div class="progress-fill" :style="{ backgroundColor: progressMainColor, width: '65%' }"></div>
              <!-- 3 milestone circles: reached ones use main color, not reached uses base color -->
              <div class="progress-milestone star" :style="{ left: '15%', backgroundColor: progressMainColor }">
                <i class="fa fa-star"></i>
              </div>
              <div class="progress-milestone star" :style="{ left: '45%', backgroundColor: progressMainColor }">
                <i class="fa fa-star"></i>
              </div>
              <div class="progress-milestone star not-reached" :style="{ left: '96%', backgroundColor: progressBaseColor }">
                <i class="fa fa-star"></i>
              </div>
              <!-- Current position indicator at 65% -->
              <div class="progress-current" :style="{ left: '65%' }">
                <!-- Arrow above the current circle -->
                <div class="progress-arrow"></div>
                <!-- Small circle indicating current position -->
                <div class="progress-circle"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoyaltyLevelOverviewMobilePreview",
  props: {
    initialPreviewImage: String,
    initialTitle: String,
    initialShowExpiringPoints: {
      type: [Boolean, String],
      default: false
    },
    initialExpiringPointsButton: {
      type: String,
      default: ""
    },
    initialShowCurrentLevel: {
      type: [Boolean, String],
      default: false
    },
    initialCurrentLevelText: {
      type: String,
      default: ""
    },
    initialProgressBaseColor: {
      type: String,
      default: "#D9D9D9"
    },
    initialProgressMainColor: {
      type: String,
      default: "#FE4300"
    }
  },
  data() {
    return {
      previewImage: this.initialPreviewImage || null,
      title: this.initialTitle || "",
      showExpiringPoints: this.parseBoolean(this.initialShowExpiringPoints),
      expiringPointsButton: this.initialExpiringPointsButton || "Davon verfallen bald: ",
      showCurrentLevel: this.parseBoolean(this.initialShowCurrentLevel),
      currentLevelText: this.initialCurrentLevelText,
      progressBaseColor: this.initialProgressBaseColor,
      progressMainColor: this.initialProgressMainColor
    };
  },
  methods: {
    parseBoolean(value) {
      return value === true || value === "true" || value === "1" || value === 1;
    }
  },
  mounted() {
    window.addEventListener("show-current-level-updated", (event) => {
      this.showCurrentLevel = this.parseBoolean(event.detail);
    });
    window.addEventListener("current-level-text-updated", (event) => {
      this.currentLevelText = event.detail;
    });
    window.addEventListener("progress-base-color-updated", (event) => {
      this.progressBaseColor = event.detail;
    });
    window.addEventListener("progress-main-color-updated", (event) => {
      this.progressMainColor = event.detail;
    });
  }
};
</script>

<style scoped>
.iphone-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* iPhone Frame */
.iphone-frame {
  width: 390px; /* iPhone width */
  height: 844px; /* iPhone height */
  background: #fff;
  border-radius: 40px;
  border: 8px solid #222;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
}

/* Notch (Dynamic Island look) */
.iphone-notch {
  width: 140px;
  height: 35px;
  background: #222;
  border-radius: 20px;
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 5px;
}

/* Notch elements */
.camera {
  width: 12px;
  height: 12px;
  background: black;
  border-radius: 50%;
}
.sensor {
  width: 8px;
  height: 8px;
  background: grey;
  border-radius: 50%;
}
.speaker {
  width: 40px;
  height: 5px;
  background: darkgray;
  border-radius: 3px;
}

/* Screen */
.screen {
  flex-grow: 1;
  background: white;
  margin-top: 50px; /* Space for notch */
  position: relative;
}

/* Background Image */
.background-image {
  width: 100%;
  height: 200px;
  background-size: cover;
  background-position: center;
}

/* Points Overview Card */
.points-card {
  width: 80%;
  background: white;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  padding: 15px;
  position: absolute;
  top: 90px; /* Position below background */
  left: 50%;
  transform: translateX(-50%);
}

.points-card h4 {
  font-size: 16px;
  color: black;
  margin-bottom: 5px;
}

.points {
  font-size: 32px;
  font-weight: bold;
  color: black;
}

.expiring-points {
  font-size: 14px;
  color: #FE4300;
  text-decoration: underline;
}

.info-btn {
  width: 100%;
  padding: 10px;
  background: black;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-weight: bold;
  margin-top: 10px;
}

/* Level Section (Progress Bar Area) */
.level-section {
  position: absolute;
  width: 80%;
  left: 50%;
  transform: translateX(-50%);
  top: 300px; /* Adjust as needed */
  text-align: left;
}

.current-level-text {
  font-weight: bold;
  font-size: medium;
  margin-bottom: 25px;
  float: left;
}

/* Progress Wrapper */
.progress-wrapper {
  position: relative;
  width: 100%;
  margin-top: 25px;
}

/* Progress Bar */
.progress-bar {
  position: relative;
  height: 10px;
  border-radius: 5px;
  background-color: #ccc;
  margin: 0 auto;
  width: 100%;
}

/* Progress Fill */
.progress-fill {
  height: 100%;
  border-radius: 5px;
  position: absolute;
  top: 0;
  left: 0;
}

/* Milestone Circles */
.progress-milestone {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: 2px solid white;
}

/* Reached milestone uses main color (bound in template) */
.progress-milestone.star i {
  color: #fff;
  font-size: 14px;
}

/* Not reached milestone: use base color (bound in template) */
.not-reached {
  /* No extra styles here – backgroundColor is set dynamically */
}

/* Current Position Indicator */
.progress-current {
  position: absolute;
  top: 0;
  transform: translate(-100%, -50%);
}

/* Arrow Above Current Indicator */
.progress-arrow {
  width: 0;
  height: 0;
  margin: 0 auto;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid gray;
  transform: translateY(-6px);
}

/* Current Indicator Circle */
.progress-circle {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin: 0 auto;
  margin-top: 2px;
  outline: 2px solid white;
}
</style>